import { FeatureGroupProps } from "@made-people/blueprint-feature-group";

export const FeatureGroup: FeatureGroupProps = {
  theme: { background: "surface-1" },
};
